import React, { useState, useEffect, useRef } from "react";
import "../styles/layout/ClientForm.scss";
import "../styles/layout/LandingPage.scss";
import {
  Box,
  Container,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  Button,
  Dialog,
  FormControl,
  InputLabel,
  Paper,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { LocalizationProvider, MobileTimePicker } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Snackbar, Alert } from "@mui/material";
import dayjs from "dayjs";
import emailjs from "@emailjs/browser";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#ff0099" },
    background: { default: "#121212", paper: "#000000" },
  },
});

const ClientForm = () => {
  const [meetingDuration, setMeetingDuration] = React.useState(15); // Default value set to 15

  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const showToast = (message, severity) => {
    setToast({ open: true, message, severity });
  };

  const [hour, setHour] = useState("06");
  const [minute, setMinute] = useState("30");
  const [ampm, setAmPm] = useState("PM");

  const hours = Array.from({ length: 12 }, (_, i) =>
    String(i + 1).padStart(2, "0")
  );
  const minutes = Array.from({ length: 60 }, (_, i) =>
    String(i).padStart(2, "0")
  );

  const [step, setStep] = useState(0);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    projectDescription: "",
    selectedDate: null,
    meetingDuration: 15,
    zone: "",
    hour: "06",
    minute: "30",
    ampm: "PM",
  });

  const [errors, setErrors] = useState({});
  const [isChecked, setIsChecked] = useState(false);
  const [time, setTime] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [zone, setZone] = React.useState("");
  const [openZone, setOpenZone] = React.useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {}, [step]);

  const handleCloseToast = () => {
    setToast({ ...toast, open: false });
  };

  const handleDateChange = (date) => {
    setFormData((prev) => ({
      ...prev,
      selectedDate: date.format("YYYY-MM-DD"), // Format date before storing
    }));
    handleStep(1); // Move to next step
  };

  const handleMeetingDurationChange = (event) => {
    setFormData((prev) => ({
      ...prev,
      meetingDuration: event.target.value,
    }));
    setMeetingDuration(event.target.value);
  };

  const handleTimeZoneChange = (event) => {
    setFormData((prev) => ({
      ...prev,
      zone: event.target.value,
    }));
    setZone(event.target.value);
  };

  const handleTimeChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    if (field === "hour") {
      setHour(value);
    } else if (field === "minute") {
      setMinute(value);
    } else {
      setAmPm(value);
    }
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Name is required.";
    if (!formData.phone.trim()) newErrors.phone = "Phone is required.";
    if (!formData.email.trim()) newErrors.email = "Email is required.";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Invalid email format.";
    if (!formData.projectDescription.trim())
      newErrors.projectDescription = "Project description is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isChecked) {
      showToast("Please check the box to proceed.", "warning");
      return;
    }

    if (!validateForm()) {
      showToast("Please fill in all required fields correctly.", "error");
      return;
    }

    const templateParams = {
      name: formData.name,
      email: formData.email,
      selectedDate: formData.selectedDate,
      hour: formData.hour,
      minute: formData.minute,
      ampm: formData.ampm,
      duration: formData.duration,
      zone: formData.zone,
      phone: formData.phone,
      projectDescription: formData.projectDescription,
    };

    try {
      const result = await emailjs.send(
        'service_m4ptwls',
        'template_it59yga',
        templateParams,
        'SLqBYvM3sQOsswwCz'
      );
      console.log("Email sent successfully:", result.text);
      showToast("Email sent successfully!", "success");
      setFormData({
        name: "",
        email: "",
        selectedDate: "",
        hour: "",
        minute: "",
        ampm: "AM",
        duration: "",
        zone: "",
        phone: "",
        projectDescription: "",
        acceptedFiles: null,
    });
      setIsChecked(false);
    } catch (error) {
      console.error("Failed to send email:", error);
      showToast("Failed to send email. Please try again later.", "error");

    }

    showToast("Form submitted successfully!", "success");
    console.log("Final Form Data:", formData); // This is the final payload
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleCloseZone = () => {
    setOpenZone(false);
  };

  const handleOpenZone = () => {
    setOpenZone(true);
  };

  const handleStep = (stepper) => {
    setStep(stepper);
  };

  return (
    <div className="clientForm">
      <div className="clientForm__title">Have Project in Mind</div>
      <div className="clientForm__mainFrame">
        <Container
          sx={{ padding: "5% 0 0 0", margin: "1", maxWidth: "90% !important" }}
        >
          <Box
            className="inputAndInfoBox"
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              height: "auto",
              padding: "0 0 0 1%",
              gap: "100px",
              alignItems: "center",
            }}
          >
            {step === 0 && (
              <Box
                className="inputForm"
                sx={{
                  padding: "0 0 0 0",
                  backgroundColor: "#000000",
                  flex: "1",
                  borderRadius: "43px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DateCalendar"]}>
                    <DateCalendar
                      sx={{
                        "& .MuiDayCalendar-weekDayLabel": { color: "#fff" },
                        "& .Mui-disabled": {
                          color: "grey !important",
                          opacity: 8,
                        },
                      }}
                      dayOfWeekFormatter={(day) =>
                        day.$d.toDateString().substr(0, 3)
                      }
                      onChange={(date) => handleDateChange(date)}
                      minDate={dayjs()}
                      slotProps={{
                        calendarHeader: { sx: { color: "#fff" } },
                        leftArrowIcon: {
                          sx: {
                            color: "#fff",
                            fontSize: "40px",
                            fontWeight: "normal !important",
                          },
                        },
                        rightArrowIcon: {
                          sx: {
                            color: "#fff",
                            fontSize: "40px",
                            fontWeight: "normal !important",
                          },
                        },
                        // disableFuture: false,
                        day: {
                          sx: {
                            color: "#fff",
                            borderRadius: "2px",
                            borderColor: "#2196f3",
                            backgroundColor: "transparent",
                          },
                        },
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Box>
            )}

            {step === 1 && (
              <Box
                className="inputForm"
                sx={{
                  padding: "0 0 0 0",
                  backgroundColor: "#000",
                  flex: "1",
                  borderRadius: "43px",
                  flexDirection: "column",
                  display: "flex",
                }}
              >
                <Typography
                  variant="body2"
                  component="span"
                  fontFamily={"'Inter', sans-serif"}
                  fontSize={16}
                  sx={{
                    color: "#fff",
                    fontWeight: "bold",
                    m: "32px 32px 10px 32px",
                  }}
                >
                  Meeting duration
                </Typography>
                <Select
                  labelId="demo-controlled-open-select-label"
                  id="demo-controlled-open-select"
                  open={open}
                  onClose={handleClose}
                  onOpen={handleOpen}
                  value={meetingDuration}
                  onChange={handleMeetingDurationChange}
                  defaultValue={15}
                  sx={{
                    color: "#000",
                    backgroundColor: "#FFDEF4",
                    m: "0 32px 5px 32px",
                    padding: "5px 10px !important",
                  }}
                >
                  <MenuItem value={15}>15 mins</MenuItem>
                  <MenuItem value={30}>30 mins</MenuItem>
                  <MenuItem value={45}>45 mins</MenuItem>
                  <MenuItem value={60}>60 mins</MenuItem>
                </Select>

                <Typography
                  variant="body2"
                  component="span"
                  fontFamily={"'Inter', sans-serif"}
                  fontSize={12}
                  sx={{
                    color: "#fff",
                    fontWeight: "normal",
                    m: "32px 32px 5px 32px",
                  }}
                >
                  What time works best?
                </Typography>

                <Typography
                  variant="body2"
                  component="span"
                  fontFamily={"'Inter', sans-serif"}
                  fontSize={16}
                  sx={{
                    color: "#fff",
                    fontWeight: "bold",
                    m: "0px 32px 10px 32px",
                  }}
                >
                  Showing times for 9 January 2025
                </Typography>

                <Box
                  sx={{
                    backgroundColor: "#860059",
                    borderRadius: "20px",
                    m: "32px 32px 10px 32px",
                    height: "160px",
                    flexDirection: "column",
                    display: "flex",
                  }}
                >
                  <Select
                    labelId="demo-controlled-open-select-label"
                    id="demo-controlled-open-select"
                    open={openZone}
                    onClose={handleCloseZone}
                    onOpen={handleOpenZone}
                    value={zone}
                    onChange={handleTimeZoneChange}
                    displayEmpty
                    sx={{
                      color: "#000",
                      backgroundColor: "#FFDEF4",
                      m: "32px 32px 5px 32px",
                      padding: "5px 10px !important",
                    }}
                  >
                    <MenuItem value="" disabled>
                      Select Time Zone
                    </MenuItem>
                    <MenuItem value={"UTC"}>UTC</MenuItem>
                    <MenuItem value={"Noumea"}>Pacific/Noumea</MenuItem>
                    <MenuItem value={"Australia"}>Australia/Adelaide</MenuItem>
                    <MenuItem value={"Tokyo"}>Asia/Tokyo</MenuItem>
                    <MenuItem value={"Shanghai"}>Asia/Shanghai</MenuItem>
                    <MenuItem value={"Nairobi"}>Africa/Nairobi</MenuItem>
                    <MenuItem value={"Paris"}>Europe/Paris</MenuItem>
                    <MenuItem value={"New_York"}>America/New_York</MenuItem>
                    <MenuItem value={"Buenos_Aires"}>
                      America/Buenos_Aires
                    </MenuItem>
                    <MenuItem value={"Tahiti"}>Pacific/Tahiti</MenuItem>
                  </Select>
                  <Typography
                    variant="body2"
                    component="span"
                    fontFamily={"'Inter', sans-serif"}
                    fontSize={16}
                    sx={{
                      color: "#fff",
                      fontWeight: "normal",
                      m: "32px 32px 5px 32px",
                      textAlign: "center",
                    }}
                  >
                    UTC +05:30 New Delhi, Mumbai, Calcutta
                  </Typography>
                </Box>
                <Box
                  sx={{
                    backgroundColor: "transparent",
                    borderRadius: "20px",
                    m: "32px",
                    flexDirection: "row",
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}
                >
                  <Button
                    onClick={() => {
                      handleStep(0);
                    }}
                    sx={{
                      border: "1px solid #4E4E4E",
                      color: "#CDCDCD",
                      width: "45%",
                      borderRadius: "9px",
                      textTransform: "capitalize",
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => {
                      handleStep(2);
                    }}
                    sx={{
                      border: "1px solid #F005A2",
                      color: "#fff",
                      width: "45%",
                      borderRadius: "9px",
                      textTransform: "capitalize",
                      background: "#F005A2",
                    }}
                  >
                    Continue
                  </Button>
                </Box>
              </Box>
            )}

            {step === 2 && (
              <Box
                className="inputForm"
                sx={{
                  padding: "2%",
                  backgroundColor: "#000",
                  flex: "1",
                  borderRadius: "43px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <ThemeProvider theme={darkTheme}>
                  <Box
                    p={3}
                    sx={{
                      backgroundColor: "background.paper",
                      borderRadius: 2,
                      width: { xs: 300, md: 320 },
                    }}
                  >
                    {/* Section Heading */}
                    <Typography variant="h6" color="white" gutterBottom>
                      Set time
                    </Typography>

                    {/* Time Selection Box */}
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      p={2}
                      sx={{
                        borderRadius: 2,
                        border: "1px solid #666",
                      }}
                    >
                      {/* Hour Dropdown */}
                      <Select
                        value={hour}
                        onChange={(e) =>
                          handleTimeChange("hour", e.target.value)
                        }
                        variant="standard"
                        sx={{ color: "white", minWidth: 60 }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              height: "100px",
                            },
                          },
                        }}
                      >
                        {hours.map((h) => (
                          <MenuItem key={h} value={h}>
                            {h}
                          </MenuItem>
                        ))}
                      </Select>

                      <Typography color="white">:</Typography>

                      {/* Minute Dropdown */}
                      <Select
                        value={minute}
                        onChange={(e) =>
                          handleTimeChange("minute", e.target.value)
                        }
                        variant="standard"
                        sx={{ color: "white", minWidth: 60 }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              height: "100px",
                            },
                          },
                        }}
                      >
                        {minutes.map((m) => (
                          <MenuItem key={m} value={m}>
                            {m}
                          </MenuItem>
                        ))}
                      </Select>

                      {/* AM/PM Dropdown */}
                      <Select
                        value={ampm}
                        onChange={(e) =>
                          handleTimeChange("ampm", e.target.value)
                        }
                        variant="standard"
                        sx={{ color: "white", minWidth: 60 }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              height: "100px",
                            },
                          },
                        }}
                      >
                        <MenuItem value="AM">AM</MenuItem>
                        <MenuItem value="PM">PM</MenuItem>
                      </Select>
                    </Box>
                  </Box>
                </ThemeProvider>

                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    width: "65%",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    onClick={() => {
                      handleStep(0);
                    }}
                    sx={{
                      border: "1px solid #4E4E4E",
                      color: "#CDCDCD",
                      width: "45%",
                      borderRadius: "9px",
                      textTransform: "capitalize",
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => {
                      handleStep(3);
                    }}
                    sx={{
                      border: "1px solid #F005A2",
                      color: "#fff",
                      width: "45%",
                      borderRadius: "9px",
                      textTransform: "capitalize",
                      background: "#F005A2",
                    }}
                  >
                    Continue
                  </Button>
                </Box>
              </Box>
            )}

            {step === 3 && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "0 !important",
                    margin: "0 !important",
                    width: { xs: "100%", md: "50%" },
                  }}
                >
                  <Box
                    className="inputForm"
                    sx={{
                      padding: "3% 0 3% 2%",
                      backgroundColor: "#FFFFFF",
                      borderRadius: { xs: "20px", md: "43px" },
                    }}
                  >
                    <TextField
                      className="inputText"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      variant="standard"
                      label="Name"
                      sx={{
                        "& .MuiInputLabel-root": {
                          color: "#000", // Default label color
                          fontSize: "20px",
                          fontFamily: "Inter, sans-serif",
                        },
                        "& .MuiInputLabel-root.Mui-focused": {
                          color: "#000", // Prevent label from changing color on focus
                        },
                        "& .MuiInput-underline:before": {
                          borderBottom: "1px solid #000", // Normal underline color
                        },
                        "& .MuiInput-underline:hover:before": {
                          borderBottom: "2px solid #000", // Thicker underline on hover
                        },
                        "& .MuiInput-underline:after": {
                          borderBottom: "2px solid #000", // Active underline color
                        },
                        width: "90%",
                        paddingBottom: "3.5%",
                      }}
                    />
                    <TextField
                      className="inputText"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      variant="standard"
                      label="Phone"
                      sx={{
                        "& .MuiInputLabel-root": {
                          color: "#000", // Default label color
                          fontSize: "20px",
                          fontFamily: "Inter, sans-serif",
                        },
                        "& .MuiInputLabel-root.Mui-focused": {
                          color: "#000", // Prevent label from changing color on focus
                        },
                        "& .MuiInput-underline:before": {
                          borderBottom: "1px solid #000", // Normal underline color
                        },
                        "& .MuiInput-underline:hover:before": {
                          borderBottom: "2px solid #000", // Thicker underline on hover
                        },
                        "& .MuiInput-underline:after": {
                          borderBottom: "2px solid #000", // Active underline color
                        },
                        width: "90%",
                        paddingBottom: "3.5%",
                      }}
                    />
                    <TextField
                      className="inputText"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      variant="standard"
                      label="Email"
                      sx={{
                        "& .MuiInputLabel-root": {
                          color: "#000", // Default label color
                          fontSize: "20px",
                          fontFamily: "Inter, sans-serif",
                        },
                        "& .MuiInputLabel-root.Mui-focused": {
                          color: "#000", // Prevent label from changing color on focus
                        },
                        "& .MuiInput-underline:before": {
                          borderBottom: "1px solid #000", // Normal underline color
                        },
                        "& .MuiInput-underline:hover:before": {
                          borderBottom: "2px solid #000", // Thicker underline on hover
                        },
                        "& .MuiInput-underline:after": {
                          borderBottom: "2px solid #000", // Active underline color
                        },
                        width: "90%",
                        paddingBottom: "3.5%",
                      }}
                    />
                    <TextField
                      className="inputText"
                      name="projectDescription"
                      value={formData.projectDescription}
                      onChange={handleInputChange}
                      variant="standard"
                      label="Describe your Project"
                      sx={{
                        "& .MuiInputLabel-root": {
                          color: "#000", // Default label color
                          fontSize: "20px",
                          fontFamily: "Inter, sans-serif",
                        },
                        "& .MuiInputLabel-root.Mui-focused": {
                          color: "#000", // Prevent label from changing color on focus
                        },
                        "& .MuiInput-underline:before": {
                          borderBottom: "1px solid #000", // Normal underline color
                        },
                        "& .MuiInput-underline:hover:before": {
                          borderBottom: "2px solid #000", // Thicker underline on hover
                        },
                        "& .MuiInput-underline:after": {
                          borderBottom: "2px solid #000", // Active underline color
                        },
                        width: "90%",
                      }}
                    />
                  </Box>
                </Box>
              </>
            )}

            {/* <Box
              className="infoContent"
              sx={{ display: "flex", flex: "1", textAlign: "left" }}
            >
              <div
                style={{
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontSize: "17.5px",
                  lineHeight: "1.2",
                  fontWeight: "400",
                  letterSpacing: "0.4px",
                  
                }}
              >
                <span style={{
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontSize: "27.5px",
                  lineHeight: "1.2",
                  fontWeight: "600",
                  letterSpacing: "1px",
                }}>Enquiry</span>
                <ul
                  style={{
                    listStyleType: "none", // Remove default bullets
                    paddingLeft: "0", // Align with content
                  }}
                >
                  {[
                    "Let Tecloq’s free consultation introduce you to the power of automation that scales with you.",
                    "If you’ve got questions, our experts will have the answers:",
                    "Discover automation tools that fit just right for your business size and goals.",
                    "Learn how to boost your current operations without the hassle.",
                    "Expand your automation as your business grows, effortlessly.",
                    "See how automation can deliver real, quantifiable benefits.",
                    "Gain insights from successes in your industry.",
                    "Move forward with digital solutions that prepare you for tomorrow.",
                  ].map((text, index) => (
                    <li
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginBottom: "8px", // Adds spacing between items
                      }}
                    >
                      <img
                        src="/assets/BigData/DataLake/charm_circle-tick.png"
                        alt={`icon-${index}`}
                        style={{ width: "20px", height: "20px" }}
                      />
                      {text}
                    </li>
                  ))}
                </ul>
              </div>
            </Box> */}
            <Box
              className="infoContent"
              sx={{
                display: "flex",
                flex: "1",
                textAlign: "left",
              }}
            >
              <div
                style={{
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontSize: "17.5px",
                  lineHeight: "1.2",
                  fontWeight: "400",
                  letterSpacing: "0.4px",
                }}
              >
                <span
                  style={{
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    fontSize: "27.5px",
                    lineHeight: "1.2",
                    fontWeight: "600",
                    letterSpacing: "1px",
                  }}
                >
                  Enquiry
                </span>
                <ul
                  style={{
                    listStyleType: "none",
                    paddingLeft: "0",
                  }}
                >
                  {[
                    "Let Tecloq’s free consultation introduce you to the power of automation that scales with you.",
                    "If you’ve got questions, our experts will have the answers:",
                    "Discover automation tools that fit just right for your business size and goals.",
                    "Learn how to boost your current operations without the hassle.",
                    "Expand your automation as your business grows, effortlessly.",
                    "See how automation can deliver real, quantifiable benefits.",
                    "Gain insights from successes in your industry.",
                    "Move forward with digital solutions that prepare you for tomorrow.",
                  ].map((text, index) => (
                    <Box
                      component="li"
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginBottom: "8px",
                        fontSize: "16px", // Desktop size
                        lineHeight: "1.5",
                        "@media (max-width: 600px)": {
                          fontSize: "12px", // Mobile size
                          gap: "6px",
                          marginBottom: "6px",
                        },
                      }}
                    >
                      <Box
                        component="img"
                        src="/assets/BigData/DataLake/charm_circle-tick.png"
                        alt={`icon-${index}`}
                        sx={{
                          width: "20px",
                          height: "20px",
                          "@media (max-width: 600px)": {
                            width: "16px", // Adjust size for mobile
                            height: "16px",
                          },
                        }}
                      />
                      {text}
                    </Box>
                  ))}
                </ul>
              </div>
            </Box>
          </Box>
        </Container>
        {step === 3 && (
          <>
            {/* <Container
              sx={{
                padding: "3% 0 0 10% !important",
                margin: "0",
                maxWidth: "100% !important",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  padding: "0",
                  margin: "0",
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        "& .MuiSvgIcon-root": {
                          color: "#F005A2",
                          fontSize: "30px",
                        },
                        "& .Mui-checked": {
                          color: "#F005A2", // Checked color
                        },
                        paddingRight: "4%",
                      }}
                      required
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                    />
                  }
                  label={
                    <Typography
                      variant="body2"
                      component="span"
                      fontFamily={"'Inter', sans-serif"}
                      fontSize={16}
                    >
                      <strong>Tecloq</strong> is committed to protecting and
                      respecting your privacy,
                      <br />
                      By clicking submit below, you consent to allow{" "}
                      <strong>Tecloq</strong> to process the personal
                      information submitted above to provide you the content
                      requested.
                      <br />
                      Please review our Privacy Policy.
                    </Typography>
                  }
                />
              </Box>
            </Container>
            <Container
              sx={{
                padding: "4% 0 0 85% !important",
                margin: "0",
                maxWidth: "100% !important",
              }}
            >
              <div
                className="submitBtn"
                style={{
                  display: "flex",
                  width: "150.84px",
                  height: "52.23px",
                  backgroundColor: isChecked ? "#F005A2" : "#FF5BC7",
                  borderRadius: "45.25px",
                  opacity: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0 2% 0 2%",
                  cursor: isChecked ? "pointer" : "not-allowed",
                }}
                onClick={isChecked ? handleSubmit : null}
              >
                <div
                  className="submitBtn__Text"
                  style={{
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    fontSize: "21px",
                    letterSpacing: "8%",
                    fontWeight: "700",
                  }}
                >
                  Submit
                </div>
                <div
                  className="submitBtn__Arrow"
                  style={{
                    width: "32.84px",
                    height: "32.23px",
                    backgroundColor: "#FFFFFF",
                    borderRadius: "45.25px",
                    opacity: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft: "7%",
                  }}
                >
                  <ArrowForwardIcon></ArrowForwardIcon>
                </div>
              </div>
            </Container> */}
            <Container
              sx={{
                padding: "3% 0 0 10% !important",
                margin: "0",
                maxWidth: "100% !important",
                "@media (max-width: 600px)": {
                  padding: "5% 5% 0 5% !important", // Adjust padding for smaller screens
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  padding: "0",
                  margin: "0",
                  flexDirection: { xs: "column", sm: "row" }, // Stack vertically on mobile
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{
                        "& .MuiSvgIcon-root": {
                          color: "#F005A2",
                          fontSize: "30px",
                          "@media (max-width: 600px)": {
                            fontSize: "24px", // Smaller checkbox for mobile
                          },
                        },
                        "& .Mui-checked": {
                          color: "#F005A2",
                        },
                        paddingRight: "4%",
                      }}
                      required
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                    />
                  }
                  label={
                    <Typography
                      variant="body2"
                      component="span"
                      fontFamily={"'Inter', sans-serif"}
                      fontSize={16}
                      sx={{
                        fontSize: "16px",
                        "@media (max-width: 600px)": {
                          fontSize: "14px", // Smaller font size on mobile
                        },
                      }}
                    >
                      <strong>Tecloq</strong> is committed to protecting and
                      respecting your privacy,
                      <br />
                      By clicking submit below, you consent to allow{" "}
                      <strong>Tecloq</strong> to process the personal
                      information submitted above to provide you the content
                      requested.
                      <br />
                      Please review our Privacy Policy.
                    </Typography>
                  }
                />
              </Box>
            </Container>

            <Container
              sx={{
                padding: "4% 0 0 85% !important",
                margin: "0",
                maxWidth: "100% !important",
                "@media (max-width: 600px)": {
                  padding: "5% 5% 0 5% !important", // Center align on mobile
                  display: "flex",
                  justifyContent: "center",
                  marginBottom:"20px"
                },
              }}
            >
              <div
                className="submitBtn"
                style={{
                  display: "flex",
                  width: "150.84px",
                  height: "52.23px",
                  backgroundColor: isChecked ? "#F005A2" : "#FF5BC7",
                  borderRadius: "45.25px",
                  opacity: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0 2% 0 2%",
                  cursor: isChecked ? "pointer" : "not-allowed",
                }}
                onClick={isChecked ? handleSubmit : null}
              >
                <div
                  className="submitBtn__Text"
                  style={{
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    fontSize: "21px",
                    letterSpacing: "8%",
                    fontWeight: "700",
                    "@media (max-width: 600px)": {
                      fontSize: "18px", // Smaller text size on mobile
                    },
                  }}
                >
                  Submit
                </div>
                <div
                  className="submitBtn__Arrow"
                  style={{
                    width: "32.84px",
                    height: "32.23px",
                    backgroundColor: "#FFFFFF",
                    borderRadius: "45.25px",
                    opacity: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft: "7%",
                    "@media (max-width: 600px)": {
                      width: "28px", // Smaller arrow size on mobile
                      height: "28px",
                      marginLeft: "5%",
                    },
                  }}
                >
                  <ArrowForwardIcon />
                </div>
              </div>
            </Container>
          </>
        )}
        {/* Snackbar for Toast Messages */}
        <Snackbar
          open={toast.open}
          autoHideDuration={3000} // 3 seconds
          onClose={handleCloseToast}
          anchorOrigin={{ vertical: "top", horizontal: "right" }} // Top-right position
        >
          <Alert
            onClose={handleCloseToast}
            severity={toast.severity}
            sx={{ width: "100%" }}
          >
            {toast.message}
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
};

export default ClientForm;
